var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64435 13.1414V11.0009C4.64435 10.4546 5.09053 10.0116 5.64091 10.0116H7.65284C7.91714 10.0116 8.17062 10.1159 8.35751 10.3014C8.5444 10.4869 8.6494 10.7386 8.6494 11.0009V13.1414C8.64773 13.3685 8.73746 13.5869 8.89867 13.7481C9.05988 13.9094 9.27925 14 9.50807 14H10.8807C11.5218 14.0017 12.1371 13.75 12.591 13.3006C13.0449 12.8512 13.3 12.2409 13.3 11.6045V5.50681C13.3 4.99273 13.0705 4.50509 12.6732 4.17527L8.00383 0.473109C7.19157 -0.176007 6.02779 -0.155049 5.23978 0.522886L0.676909 4.17527C0.260919 4.49537 0.0122866 4.98445 0 5.50681V11.5983C0 12.9247 1.08317 14 2.41932 14H3.76061C4.23586 14 4.6221 13.6194 4.62555 13.1476L4.64435 13.1414Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.14d94a2ef02848c0fe084780b5a612fc.svg";
export { ForwardRef as ReactComponent };